import React, { useState } from "react";
import { IonAlert, IonButton, IonItem, IonLabel, IonText } from "@ionic/react";
import { StatementModel } from "../models/GlobalModels";
import { parseISO } from "date-fns/parseISO";
import { format } from "date-fns/format";

import "./EquipmentItem.scss";

interface Props {
    statement: StatementModel;
    acceptStatementLoading: boolean;
    onAcceptStatement: (statementId: number) => void;
}

const StatementItem: React.FC<Props> = ({
    statement,
    acceptStatementLoading,
    onAcceptStatement,
}) => {
    const [showAlert, setShowAlert] = useState<boolean>(false);

    return (
        <div className="statementItemWrapper">
            <IonItem lines="none" button={false} detail={false}>
                <IonLabel>
                    <h2 className="title">
                        <IonText>{statement.name ?? ""}</IonText>
                    </h2>
                    <IonText>
                        <small>
                            Érvényes ekkortól:{" "}
                            <b>
                                {format(
                                    parseISO(statement.valid_from),
                                    "yyyy-MM-dd"
                                )}
                            </b>
                        </small>
                    </IonText>
                    <br />
                    {(statement?.changelog_content ?? "") !== "" && (
                        <>
                            <br />
                            <IonText style={{ whiteSpace: "pre-wrap" }}>
                                <small>
                                    <b>{statement?.changelog_content}</b>
                                </small>
                            </IonText>
                        </>
                    )}
                    {(statement?.doc_url ?? "") !== "" && (
                        <div style={{ marginTop: "20px" }}>
                            <IonText>
                                <small>
                                    A teljes dokumentum{" "}
                                    <a
                                        href={statement?.doc_url}
                                        target="_blank"
                                        rel="noreferrer"
                                    >
                                        itt olvasható
                                    </a>
                                </small>
                            </IonText>
                        </div>
                    )}
                    <IonButton
                        disabled={acceptStatementLoading}
                        fill="solid"
                        color="success"
                        expand="block"
                        style={{ marginTop: "30px" }}
                        onClick={() => setShowAlert(true)}
                    >
                        Elfogadás
                    </IonButton>
                </IonLabel>
            </IonItem>

            <IonAlert
                isOpen={showAlert}
                onDidDismiss={() => setShowAlert(null)}
                message={`Elfogadja a nyilatkozatot? (${statement.name})`}
                buttons={[
                    {
                        text: "Igen",
                        handler: () => onAcceptStatement(statement.id),
                    },
                    {
                        text: "Mégse",
                        role: "cancel",
                    },
                ]}
            />
        </div>
    );
};

export default StatementItem;
